import paymentApi from "api/PaymentApi";
import history from "core/helper/Helper";
import { FETCH_FEE_SHIP_SUCCESS } from "redux/ActionTypes/PaymentTypes";
import { PAYMENT_METHOD } from "shared/Constants";
import { RouterName } from "shared/RouterName";
import { activeProgress, disableProgress } from "./ProgressActionCreators";

export const fetchFeeShipSuccess = (data) => {
  return {
    type: FETCH_FEE_SHIP_SUCCESS,
    payload: data,
  };
};

export const fetchFeeShipRequest = (
  receiverProvince,
  receiverDistrict,
  weight,
  value
) => {
  return (dispatch) => {
    dispatch(activeProgress());
    paymentApi
      .getFeeShip(receiverProvince, receiverDistrict, weight, value)
      .then(
        (res) => {
          dispatch(fetchFeeShipSuccess(res.body.results[0]));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchPaymentRequest = (
  firstName,
  lastName,
  detailAddress,
  phoneNumber,
  provincial,
  district,
  commune,
  paymentMethodName,
  carts,
  email
) => {
  return (dispatch) => {
    const userInformation = {
      firstName,
      lastName,
      detailAddress,
      phoneNumber,
      provincial,
      district,
      commune,
      email,
    };

    const paymentMethod = {
      name: paymentMethodName,
    };

    const cartDetails = carts.map((item, index) => {
      return {
        product: {
          id: item.id,
        },
        count: item.count,
      };
    });

    const cart = {
      userInformation,
      paymentMethod,
      cartDetails,
    };

    if (paymentMethod.name === PAYMENT_METHOD[0].key) {
      paymentApi.paymentOffice(cart).then(
        (res) => {
          history.push(`${RouterName.Payment.Success.url}/${res.body.id}`);
        },
        (err) => {}
      );
    } else {
      paymentApi.paymentOnline(cart).then(
        (res) => {
          window.location = res.body.url;
        },
        (err) => {}
      );
    }
  };
};
